export default __webpack_public_path__ + "static/media/yt.651dca23.webp";